import { getMetaContent } from './meta';

export const WORKSPACE_BACKGROUND_PRESET_KEYS = ['blue', 'green'] as const;
export type WorkspaceBackgroundPreset = (typeof WORKSPACE_BACKGROUND_PRESET_KEYS)[number];

export interface WorkspaceBackgroundPresetConfig {
  label: string;
  url: string;
}

export const WORKSPACE_BACKGROUND_IMAGE_PRESETS = JSON.parse(getMetaContent('workspace:background_image_presets') || '{}') as Partial<
  Record<WorkspaceBackgroundPreset, WorkspaceBackgroundPresetConfig>
>;
